








import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import BackofficeGlobalStore from '@/components/Backoffice/Store/BackofficeGlobalStore'
import EventBus from '@/plugins/EventBus'
import SurgerySolicitationReadOnlyPageComponent from '@/components/Backoffice/surgery-solicitation-readonly-page.vue'
import { permissionService } from '@/services/permission.service'
import router from '@/router/_'

@Component({ components: { SurgerySolicitationReadOnlyPageComponent } })
export default class BackofficeSurgerySolicitationDetailsView extends Vue {
  surgerySolicitationLoadedSuccesfully: boolean = false

  async created() {
    if (permissionService.hasPermission('agendamento.backoffice.solicitacao.visualizar')) {
      EventBus.$emit('setLoadingRequest', { status: true, text: 'Carregando...' })

      await this.loadingSurgerySolicitationDetails()

      EventBus.$emit('clearLoadingRequest')
    } else {
      this.redirectToDefaultPage()
    }
  }

  async loadingSurgerySolicitationDetails() {
    const { solicitacaoId: surgerySolicitationId } = this.$route.params
    this.surgerySolicitationLoadedSuccesfully = false

    this.getBackofficeGlobalStore.setBackofficeArea(this.backofficeArea)

    const response = await this.getBackofficeGlobalStore.getSolicitacaoById(surgerySolicitationId)
    if (response.success) {
      const { hospitalId } = this.getBackofficeGlobalStore.solicitacao

      await this.getBackofficeGlobalStore.getHospitalTemplate(hospitalId)

      this.surgerySolicitationLoadedSuccesfully = true
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Não foi possível carregar as informações da cirurgia', icon: 'warning', color: '#C62828' })
    }
  }

  get backofficeArea() {
    return this.getBackofficeGlobalStore.backofficeArea || this.backofficeUserDefaultArea
  }

  get backofficeUserDefaultArea() {
    if (this.getBackofficeGlobalStore.backofficeArea) {
      return this.getBackofficeGlobalStore.backofficeArea
    }
    const { defaultPage } = this.$user.profile

    if (defaultPage && defaultPage.keyAuthorized.includes('backoffice-')) {
      return defaultPage.keyAuthorized.includes('backoffice-pre-anestesico')
        ? 'preanestesia'
        : defaultPage.keyAuthorized.replace('backoffice-', '')
    }

    return 'agendamento'
  }

  redirectToDefaultPage() {
    router.back()
  }

  get getBackofficeGlobalStore() {
    return getModule(BackofficeGlobalStore, this.$store)
  }
}
